import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterControlTypes, FilterSearchOptions, FilterTypes, RiskFilterType, SelectFilterOption } from '../../../../models/risk-filter-type';
import { AgilityRiskFilterService } from '../../../../providers/agility-risk-filter.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-risk-filters',
  templateUrl: './risk-filters.component.html',
  styleUrls: ['./risk-filters.component.scss']
})
export class RiskFiltersComponent implements OnInit {
  @Input() filterType: RiskFilterType;
  @Output() filterValueChanged: EventEmitter<RiskFilterType> = new EventEmitter<RiskFilterType>();
  @Output() hideFilter: EventEmitter<FilterTypes> = new EventEmitter<FilterTypes>();
  @Input() readOnly: boolean = false;

  public filterValue: string | string[] | Date;
  public searchOption: FilterSearchOptions;
  public selectOptions: Array<SelectFilterOption>;
  public filterControlTypes = FilterControlTypes;
  public filterSearchOptions = FilterSearchOptions;
  public filterTypes = FilterTypes;

  constructor(private filterService: AgilityRiskFilterService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    this.filterValue = this.filterType.controlType === FilterControlTypes.multiselect ? [] : '';

    switch (this.filterType.controlType) {
      case FilterControlTypes.multiselect:
        this.filterService.getFilterOptions(this.filterType.id).subscribe((result: Array<SelectFilterOption>) => {
          if (this.filterType.id === FilterTypes.userManagerRole) {
            result.find(f => f.name === 'Manager').selected = true;
          }
          this.selectOptions = result;
          this.selectOptions.forEach(o => this.processOption(o));
        });
        break;
      case FilterControlTypes.date:
        this.filterValue = new Date();
        break;
    }

    if (this.filterType.controlType === FilterControlTypes.inputWithOptions) {
      this.searchOption = FilterSearchOptions.searchStartsWith;
    }

    this.onFilterChange();
  }

  processOption(option: SelectFilterOption) {
    if (this.filterType.controlType === FilterControlTypes.multiselect) {
      if (option.selected) {
        (this.filterValue as Array<string>).push(option.id);
      }

      switch (this.filterType.id) {
        case FilterTypes.userStatus:
          option.name = this.translateService.instant(`filter.statusOptions.${option.name}`);
          break;
        case FilterTypes.ansTypeUser:
          option.name = this.translateService.instant(`filter.ansUserOptions.${option.name}`);
          break;
        case FilterTypes.ansTypeVendor:
          option.name = this.translateService.instant(`filter.ansVendorOptions.${option.name}`);
          break;
        case FilterTypes.userRPXMobile:
          option.name = this.translateService.instant(`filter.rpxMobileUserOptions.${option.name}`);
          break;
        default:
          break;
      }
    }
  }

  onFilterChange(): void {
    this.filterType.value = this.filterValue;
    this.filterType.filterOption = this.searchOption;
    this.filterValueChanged.emit(this.filterType);
  }

  onHideFilter(): void {
    this.hideFilter.emit(this.filterType.id);
  }
}
